/**
 * TrackingRequest
 * @author ftgibran
 */
import {$, ObjectCollection, Model, IResource, ID, ValidationRequired, Collection, ValidationCNPJ} from 'simpli-web-sdk'
import {HttpIgnore, ResponseFill} from 'simpli-web-sdk'
import {Region} from '@/enums/Region'
import {UF} from '@/enums/UF'
import Motorista from '@/model/resource/Motorista'
import {ItrackCollection} from '@/helpers'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import * as Helper from '@/helpers'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {GroupBy} from '@/enums/GroupBy'
import {TipoSistema} from '@/enums/TipoSistema'

@HttpIgnore()
export default class TrackingRequest extends Model {
  readonly $name: string = 'TrackingRequest'

  idFilial = Helper.getIdFilial()

  @ResponseFill()
  idResponsavel: ID | null = null

  @ResponseFill()
  idMotorista: ID | null = null

  @ResponseFill()
  @ValidationCNPJ()
  documentDestinatario: string | null = null

  @ResponseFill()
  nroNotaFiscal: string | null = null

  @ResponseFill()
  uf: UF | null = null

  @ResponseFill('cte')
  cte: string | null = null

  @ResponseFill()
  region: Region | null = null

  @ResponseFill()
  cidade: string | null = null

   @ResponseFill()
   cnpjEmbTransp: string | null = null

  @ResponseFill()
  placaVeiculo: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill()
  updateAutomatically = Helper.getUpdateAutomaticallyTracking()

  @ResponseFill('idTipoCriacao')
  @ValidationRequired()
  idTipoCriacao: number | null = null

  @ResponseFill('idInsumo')
  @ValidationRequired()
  idInsumo: number | null = null

  @ResponseFill('idTipoOcorrencia')
  @ValidationRequired()
  idTipoOcorrencia: number | null = null

  @ResponseFill('idCentroDeCusto')
  @ValidationRequired()
  idCentroDeCusto: number | null = null

  @ResponseFill('idMotivoAuditoria')
  @ValidationRequired()
  idMotivoAuditoria: number | null = null

  @ResponseFill('slaPendente')
  slaStatus: DeliverySlaStatus | null = null

  @ResponseFill('manifesto')
  manifesto: string | null = null

  allRegion = ItrackCollection.allRegion.prependNull('app.all')
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')
  allTipoOcorrencia = ItrackCollection.allTipoOcorrencia
  tipoOcorrenciaNaoDevolvidaCollection = new Collection(TipoOcorrencia)
  tipoOcorrenciaDevolvidaCollection = new Collection(TipoOcorrencia)
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allAuditoriaMotivo = ItrackCollection.allAuditoriaMotivo.prependNull('app.all')
  allSistema = ItrackCollection.allSistema
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get slaStatusResource() {
    return this.allSlaStatus.get(this.slaStatus)
  }
  set slaStatusResource(val: IResource | null) {
    this.slaStatus = val && val.$id as DeliverySlaStatus || null
  }

  get regionResource() {
    return this.allRegion.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get tipoCriacaoResource() {
    return this.allSistema.get(this.idTipoCriacao)
  }
  set tipoCriacaoResource(val: IResource | null) {
    this.idTipoCriacao = val && val.$id as TipoSistema || null
  }

  get insumoResource() {
    return this.allCentroDeCusto.get(this.idInsumo)
  }
  set insumoCustoResource(val: IResource | null) {
    this.idInsumo = val && val.$id as number || null
  }

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get tipoOcorrenciaResource() {
    return this.tipoOcorrenciaNaoDevolvidaCollection.get(this.idTipoOcorrencia)
  }
  set tipoOcorrenciaResource(val: IResource | null) {
    this.idTipoOcorrencia = val && val.$id as number || null
  }

  get centroDeCustoResource() {
    return this.allCentroDeCusto.get(this.idCentroDeCusto)
  }
  set centroDeCustoResource(val: IResource | null) {
    this.idCentroDeCusto = val && val.$id as number || null
  }

}
